<template lang="pug">
  .welcome

    h2.subtitle.is-2 Settings

    .field
      label.label Temperature unit
      .control
        label(for='unitTemperature-C').radio-label
          input(type="radio", name="unitTemperature-C", v-model="unitTemperature", value="C")
          | &deg;C
        label(for='unitTemperature-F').radio-label
          input(type="radio", name="unitTemperature-F", v-model="unitTemperature", value="F")
          | F

    .field
      label.label Volume unit
      .control
        label(for='unitVolume-ml').radio-label
          input(type="radio", name="unitVolume-ml", v-model="unitVolume", value="ml")
          | ml
        label(for='unitVolume-floz').radio-label
          input(type="radio", name="unitVolume-floz", v-model="unitVolume", value="floz")
          | fl oz

    .field.has-addons
      .control
        a(@click="saveClicked").button.is-primary
          span.icon
            fa-icon(icon='save')
          span Save

      .control
        a(@click="cancelClicked").button
          span Cancel

</template>

<script>

import router from '../router'

export default {
  name: 'Settings',
  props: {
  },
  data () {
    return {
      unitTemperature: this.$localStorage.get('unitTemperature', 'C'),
      unitVolume: this.$localStorage.get('unitVolume', 'ml')
    }
  },
  methods: {
    saveClicked () {
      this.$localStorage.set('unitTemperature', this.unitTemperature)
      this.$localStorage.set('unitVolume', this.unitVolume)
      this.cancelClicked()
    },
    cancelClicked () {
      router.push({
        name: 'Welcome'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .radio-label
    padding 0 10px 0 5px
    display inline-block
    width 100px

  input
    margin 0 5px 0 0

</style>
